export default function linkToAdminPages() {
  return "/admin";
}
